import { css } from "lit";

export const textareaStyles = css`
  .textarea-wrapper {
    position: relative;
    width: 100%;
  }
  .textarea {
    outline: none;
    width: 100%;
    min-height: 80px;
    padding: var(--sds-size-space-400) var(--sds-size-space-600);
    align-items: center;
    align-self: stretch;
    box-sizing: border-box;
    color: var(--sds-color-text-default-default);
    font:
      var(--sds-typography-weight-regular) var(--sds-typography-body-size-large) / 100%
        var(--sds-typography-family-body),
      sans-serif;

    border-radius: var(--sds-size-radius-400);
    border: var(--sds-size-stroke-border) solid var(--sds-color-border-default-default);
    background: var(--sds-color-background-default-secondary);
    resize: none;

    &.with-placeholder {
      padding-top: calc(var(--sds-size-space-800) + var(--sds-size-space-100));
    }

    &:hover {
      border: var(--sds-size-stroke-border) solid var(--sds-color-border-default-tertiary);
      background: var(--sds-color-background-default-default-hover);
    }

    &:disabled {
      border: var(--sds-size-stroke-border) solid var(--sds-color-border-disabled-default);
      color: var(--sds-color-text-disabled-default);
      background: var(--sds-color-background-disabled-default);
      cursor: not-allowed;
    }

    &:-webkit-autofill {
      animation-name: wow-autocomplete-detected;
      animation-duration: 0.01s;
      animation-fill-mode: both;
    }

    @keyframes wow-autocomplete-detected {
      from {
      }
      to {
      }
    }
  }

  .input-placeholder {
    position: absolute;
    left: var(--sds-size-space-600);
    top: var(--sds-size-space-400);
    font:
      var(--sds-typography-weight-medium) var(--sds-typography-body-size-large) / 1em var(--sds-typography-family-title),
      sans-serif;
    color: var(--sds-color-text-default-tertiary);
    transition: all 0.2s ease-out;
    pointer-events: none;
    max-width: calc(100% - 80px);
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    -webkit-box-orient: vertical;

    &.active {
      top: var(--sds-size-space-300);
      font-size: var(--sds-typography-body-size-small);
    }

    &.error {
      color: var(--sds-color-text-danger-secondary);
    }

    &.disabled {
      color: var(--sds-color-text-disabled-default);
    }
  }

  .char-count {
    position: absolute;
    top: var(--sds-size-space-400);
    right: var(--sds-size-space-600);
    color: var(--sds-color-text-default-tertiary);
    font:
      var(--sds-typography-weight-regular) var(--sds-typography-body-size-small) / 100%
        var(--sds-typography-family-body),
      sans-serif;

    &.active {
      top: var(--sds-size-space-300);
    }
  }

  .placeholder-wrapper {
    position: absolute;
    top: 1px;
    left: 1px;
    right: 1px;
    background-color: var(--sds-color-background-default-secondary);
    padding: var(--sds-size-space-300) var(--sds-size-space-300);
    border-radius: var(--sds-size-radius-400);
    display: flex;
    justify-content: space-between;
    align-items: center;
    pointer-events: none;

    &.active {
      padding-bottom: var(--sds-size-space-600);
    }
  }

  .required-indicator {
    color: var(--sds-color-text-danger-secondary);
    margin-left: var(--sds-size-space-100);
  }
`;
